<header>
  <nav class="navbar navbar-expand-lg navbar-light bg-light sticky-top">
    <a class="navbar-brand" [routerLink]="['/products']">
      <img
        style="height: 50px; position: absolute; top: 5px"
        src="https://www.upay.org.in/wp-content/uploads/2020/03/icon-food-14.png"
        alt=""
      />
      <span class="ms-5"> &nbsp;&nbsp;Food order online</span>
    </a>
    <div class="navbar-nav ml-auto ml-lg-5">
      <div class="header-action-area">
        <div class="shopping-cart">
          <a
            [routerLink]="['/cart']"
            class="shopping-cart-btn"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#AsideOffcanvasCart"
            aria-controls="offcanvasRightLabel"
          >
            <i class="fa fa-shopping-cart"></i>
            <sup class="shop-count">{{ cartCount }}</sup>
          </a>
        </div>
      </div>

      <!-- <li class="nav-item">
        <a class="nav-link" [routerLink]="['/cart']">
          <i class="fa fa-shopping-cart"></i> Cart
          <span class="badge badge-primary btn-theme">{{ cartCount }}</span>
        </a>
      </li> -->
    </div>
  </nav>
</header>

<br /><br /><br />
